import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import noop from 'lodash/noop';
import { useI18n } from '../../i18n';
import { Cell } from './Cell';
export function GridBody(props) {
    const { items, getKey, columns, filter, selectable, onRowClick, selectedIds, sort } = props;
    const onClick = onRowClick || noop;
    const isEmpty = !items.length;
    const { t } = useI18n();
    const noRowsFoundText = t('component.grid.noRowsFound');
    const renderBody = props.renderBody || (({ renderRows })=>{
        return /*#__PURE__*/ _jsx("tbody", {
            "data-testid": "GridBody",
            children: renderRows()
        });
    });
    const renderRow = props.renderRow || (({ row, renderCells })=>{
        const rowKey = getKey(row);
        return /*#__PURE__*/ _jsx("tr", {
            className: classnames({
                pointer: selectable || onRowClick,
                'table-info': selectedIds.includes(rowKey)
            }),
            onClick: (e)=>onClick(row, e, items),
            children: renderCells()
        }, rowKey);
    });
    if (isEmpty) {
        return /*#__PURE__*/ _jsx("tbody", {
            "data-testid": "GridBody",
            children: /*#__PURE__*/ _jsx("tr", {
                children: /*#__PURE__*/ _jsx("td", {
                    colSpan: columns.length + 1,
                    children: /*#__PURE__*/ _jsx("p", {
                        children: /*#__PURE__*/ _jsx("em", {
                            children: noRowsFoundText
                        })
                    })
                })
            })
        });
    }
    const renderCellsFn = (item)=>{
        const rowKey = getKey(item);
        return columns.filter((col)=>col.show !== false).map((col)=>{
            const key = `id_${rowKey}_col_${col.id}`;
            const tdProps = col.tdProps || {};
            const val = col.getValue(item);
            if (col.renderCell) {
                return /*#__PURE__*/ _jsx("td", {
                    ...tdProps,
                    children: col.renderCell({
                        value: val,
                        row: item,
                        column: col,
                        filter,
                        items
                    })
                }, key);
            }
            return /*#__PURE__*/ _jsx(Cell, {
                text: (val ?? '').toString(),
                filter: filter,
                ...tdProps
            }, key);
        });
    };
    const renderRowsFn = ()=>items.map((item)=>{
            return renderRow({
                row: item,
                sort,
                columns,
                renderCells () {
                    return renderCellsFn(item);
                },
                items
            });
        });
    return renderBody({
        renderRows: renderRowsFn
    });
}
